import axios from "axios";
import { useAuth } from "./auth.service";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API;

export const useAuthService = () => {
  const { user } = useAuth();

  const getAuthHeaders = () => ({
    "Content-Type": "application/json",
    "x-access-token": user?.accessToken,
  });

  /**
   * Change user password
   * @param {Object} passwordData - Object containing currentPassword and newPassword
   * @returns {Promise} API response
   */
  const changePassword = async (passwordData) => {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/auth/change-password`,
        {
          currentPassword: passwordData.currentPassword,
          newPassword: passwordData.newPassword,
        },
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Error changing password:", error);
      if (error.response) {
        console.error("Error response:", error.response.data);
      }
      throw error;
    }
  };

  /**
   * Generate a permanent JWT token
   * @returns {Promise} API response containing permanentToken
   */
  const generatePermanentToken = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/auth/permanent-token`,
        {},
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Error generating permanent token:", error);
      if (error.response) {
        console.error("Error response:", error.response.data);
      }
      throw error;
    }
  };

  return {
    changePassword,
    generatePermanentToken,
  };
};
